import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Link } from "react-router-dom";
import "./style.css";
import { Card } from "@mui/material";

import Headline from "../Headline";

const HomeCat = (props) => {

  return (
    <section className="product-category">
      <div className="container">
        <Headline
          title="Product Categories"
          description="Do not miss the current offers until the end of March."
        />
        <Swiper
          slidesPerView={2}
          spaceBetween={20}
          navigation={false}
          loop={true}
          // touchStartPreventDefault={false}
          // simulateTouch={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            200: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            400: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            576: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 6,
              spaceBetween: 15,
            },
            1200: {
              slidesPerView: 7,
              spaceBetween: 20,
            },
          }}
        >
          {props.catData?.length !== 0 &&
            props.catData?.map((cat, index) => {
              return (
                <SwiperSlide key={index} className={``}>
                  <Link to={`/products/category/${cat._id}`}>
                    <Card
                      className="item text-center cursor"
                      sx={{
                        background: "var(--bgLight)",
                        height: "100%",
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: 3,
                        },
                      }}
                    >
                      <div className="image">
                        <img src={cat.images} />
                      </div>

                      <h6>{cat.name}</h6>
                    </Card>
                  </Link>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </section>
  );
};

export default HomeCat;
